// extracted by mini-css-extract-plugin
export default {"location":"location-yjZI4"};